<template>
    <div class="view-body">

        <div class="panel" @mouseup="select">
            <vue-office-docx :src="this.fileData" style="height: 100%;" />
        </div>
        <div class="panel">
            <div class="config">
                1、请选择文件（必须是 .docx 格式）：<input class="file-input" id="file-input" type="file" />
                <br />
                2、请输入 DeepSeek API Key ( <a href="https://platform.deepseek.com/api_keys" target="_blank">点击获取</a>）：
                <input class="key-input" v-model:="this.key" />
                <br />
                3、可以通过按钮来&nbsp;<button @click="save">存储</button>&nbsp;Key&nbsp;来方便下次使用，或者&nbsp;<button
                    @click="remove">删除</button>&nbsp;它&nbsp;
                <br />
                4、请放心，您的文件和&nbsp;Key&nbsp;将不会被上传到云端，但是您选中的部分会发送给&nbsp;AI&nbsp;提供商。
            </div>
            <div class="log-view"></div>
        </div>
    </div>
</template>

<script>

import $ from 'jquery'
import VueOfficeDocx from '@vue-office/docx'
import '@vue-office/docx/lib/index.css'
import AI from '@/js/AI.js'
import config from '@/js/config.js'

export default {
    name: 'App',
    components: {
        VueOfficeDocx
    }, data() {
        return {
            fileData: "",
            key: "",
            answering: false
        }
    }, methods: {
        select() {
            let user_selected = window.getSelection().toString().trim()
            if (user_selected === "" || this.answering) return
            this.answering = true

            this.addLog(user_selected, 'user')
            this.addLog("", 'ai')

            AI.send(config['prompts'][config['now_used']['prompt']], user_selected, (response) => {
                if (response === "[DONE]") {
                    this.answering = false
                    return
                }

                let res = JSON.parse(response)
                this.appendLog(res['choices'][0]['delta']['content'])
            }, (error) => {
                console.log(error)
                this.appendLog('请求失败，请检测 key 配置是否正确')
                this.answering = false
            })
        }, scrollToBottom() {
            let height = $('.log-view').height();
            $('.panel').scrollTop(height);
        }, addLog(content, role) {
            $("<pre class='log log_" + role + "'>" + content + "</pre>").appendTo(".log-view")
            this.scrollToBottom()
        }, appendLog(content) {
            $(".log-view :last-child").append(content)
            this.scrollToBottom()
        }, save() {
            localStorage.setItem('userData', JSON.stringify(config));
            alert("存储成功，下次可以直接使用")
        }, remove() {
            localStorage.removeItem('userData');
            alert("删除成功，下次需要重新输入key")
        }
    }, mounted() {

        const userData = localStorage.getItem('userData');
        if (userData) {
            let local_config = JSON.parse(userData)
            for (let key in local_config) {
                config[key] = local_config[key]
            }
        }

        this.key = config['keys']['deepseek']
        const fileInput = document.getElementById("file-input");
        fileInput.addEventListener("change", (event) => {
            const file = event.target.files[0];
            const reader = new FileReader();

            reader.onload = () => {
                this.fileData = reader.result
            };
            reader.onerror = () => {
                alert("读取文件时出错，请重试。", "error");
            };
            reader.readAsArrayBuffer(file);
        });

    }, watch: {
        key(now) {
            config['keys']['deepseek'] = now
            console.log(config['keys']['deepseek'])
        }
    }
}
</script>

<style>
* {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}

html,
body,
#app,
.view-body {
    height: 100%;
}

.view-body {
    display: flex;
    overflow: hidden;
}


.panel {
    box-sizing: border-box;
    width: 50%;
    border: 1px solid rebeccapurple;
    overflow: auto;
}

.config {
    padding: 10px;
    line-height: 2em;

    .key-input {
        width: 300px;
        text-align: center;
        margin-top: 10px;
        outline: none;
    }
}

.log-view {
    padding: 10px;
    text-align: center;
    font-size: 1.2em;

    .file-input {
        text-align: center;
    }

    .log {
        width: 100%;
        padding: 10px;
        border-radius: 10px;
        border: 1px solid black;
        white-space: pre-line;
        word-spacing: 2px;
        text-align: left;
    }

    .log_user {
        background-color: #79C6DB;
        margin-top: 40px;
    }

    .log_ai {
        margin-top: 10px;
        background-color: rgb(50, 138, 94);
    }
}
</style>
